import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import 'bootstrap-daterangepicker/daterangepicker.css';

import Paginator from '../../components/ui/Paginator';
import { Group } from '../../models/interfaces';
import { GroupsContext } from '../../context/group/GroupContext';

export const GroupsPage = () => {
    const [buscar, setBuscar] = useState('');
    const [pageActual, setPageActual] = useState<number>(1);

    const { groups, totalPage, loadGroups, deleteGroup, isLoading } = useContext(GroupsContext);
    const navigate = useNavigate();

    useEffect(() => {
        loadGroups(pageActual - 1);
    }, [pageActual]);

    const filteredData = groups.filter(group =>
        group.group_name.toLowerCase().includes(buscar.toLowerCase())
    );

    const handleNew = () => {
        navigate('/group');
    };

    const handleEdit = (group: Group) => {
        navigate('/group', { state: { group } });
    };

    const handleDelete = async (group_id: number) => {
        const resp = await deleteGroup(group_id);
        if (resp !== 'success') {
            alert(resp);
        }
    };

    const handleUsers = (group: Group) => {
        navigate('/group/user', { state: { group } });
    };

    const handlePermission = (group: Group) => {
        navigate('/group/permission', { state: { group } });
    };

    const getParentGroupName = (parentId: number | null) => {
        if (!parentId) return '-';
        const parent = groups.find(g => g.group_id === parentId);
        return parent ? parent.group_name : '-';
    };

    return (
        <div className="mt-5 container" style={styles.container}>
            {/* Buscador + Nuevo */}
            <div className="row justify-content-end mt-5">
                <div className="col-md-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Buscar"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                    />
                </div>

                <div className="col-md-1">
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleNew}
                    >
                        Nuevo
                    </button>
                </div>
            </div>

            <br />

            {/* Tabla */}
            <table className="table table-hover table-striped">
                <thead className="thead-dark">
                    <tr>
                        <th>Grupo</th>
                        {/* <th>Grupo padre</th> */}
                        <th>Descripción</th>
                        <th style={{ textAlign: 'center' }}>Acciones</th>
                    </tr>
                </thead>

                <tbody>
                    {filteredData.length > 0 ? (
                        filteredData.map(group => (
                            <tr key={group.group_id}>
                                <td>{group.group_name}</td>
                                {/* <td>{getParentGroupName(group.parent_group_id)}</td> */}
                                <td>{group.group_description}</td>

                                <td style={{ textAlign: 'center' }}>
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-secondary dropdown-toggle"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span className='bi bi-list'></span>
                                        </button>

                                        <ul className="dropdown-menu">
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => handleEdit(group)}
                                                >
                                                    <i className="bi bi-pencil me-2"></i>
                                                    Editar
                                                </button>
                                            </li>

                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => handleUsers(group)}
                                                >
                                                    <i className="bi bi-people me-2"></i>
                                                    Usuarios
                                                </button>
                                            </li>

                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => handlePermission(group)}
                                                >
                                                    <i className="bi bi-shield-lock me-2"></i>
                                                    Permisos
                                                </button>
                                            </li>

                                            <li>
                                                <hr className="dropdown-divider" />
                                            </li>

                                            <li>
                                                <button
                                                    className="dropdown-item text-danger"
                                                    onClick={() => handleDelete(group.group_id)}
                                                >
                                                    <i className="bi bi-trash me-2"></i>
                                                    Eliminar
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={4} className="text-center">
                                {isLoading ? "Cargando.." : "No existen grupos."}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Paginador */}
            {totalPage > 1 && (
                <Paginator
                    totalPage={totalPage}
                    pageActual={pageActual}
                    onChange={(actual) => setPageActual(actual)}
                />
            )}
        </div>
    );
};

const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
